import get from 'lodash/get'

// Get

export const bannerMessage = (state) => get(state, 'dashboard.bannerMessage')

export const errors = (state) => get(state, 'dashboard.errors')

export const eventDetailToEdit = (state) => get(state, 'dashboard.eventDetailToEdit')

export const shouldValidate = (state) => get(state, 'dashboard.shouldValidate')

export const slidingModalContent = (state) => get(state, 'dashboard.slidingModalContent')

export const wearerToEdit = (state) => get(state, 'dashboard.wearerToEdit')

// Boolean

export const editParticipantFormVisible = (state) =>
  !!get(state, 'dashboard.editParticipantFormVisible')
export const eventDetailsExpanded = (state) => !!get(state, 'dashboard.eventDetailsExpanded')
export const eventDetailsListVisible = (state) => !!get(state, 'dashboard.eventDetailsListVisible')
export const isOpen = (state) => !!get(state, 'dashboard.isOpen')
export const participantFormVisible = (state) => !!get(state, 'dashboard.participantFormVisible')
export const slidingModalIsOpen = (state) => !!get(state, 'dashboard.slidingModalIsOpen')
export const userFormVisible = (state) => !!get(state, 'dashboard.userFormVisible')

// Args

export const isEventDetailInEditMode = (state, id) => eventDetailToEdit(state) === id
